import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { StyledButton, DocumentViewer, IconButton } from "components/support";

class ViewDocumentButtonView extends Component {
  render() {
    const {
      presenter,
      viewModel,
      label,
      title,
      icon,
      tooltip,
      tooltipInfo
    } = this.props;
    const { loading, document } = viewModel;

    const button = icon => {
      if (icon) {
        if (tooltip && tooltipInfo) {
          const {
            dataTip,
            dataFor,
            id,
            type,
            effect,
            place,
            style
          } = tooltipInfo;
          return (
            <div>
              <div data-tip={dataTip} data-for={dataFor} style={style || {}}>
                <IconButton
                  mini
                  icon={icon}
                  onClick={() => presenter.onRequestDocument()}
                />
              </div>
              <ReactTooltip
                id={id}
                type={type}
                effect={effect}
                place={place || "top"}
              />
            </div>
          );
        } else {
          return (
            <IconButton
              mini
              icon={icon}
              onClick={() => presenter.onRequestDocument()}
            />
          );
        }
      } else {
        if (tooltip && tooltipInfo) {
          const {
            dataTip,
            dataFor,
            id,
            type,
            effect,
            place,
            style
          } = tooltipInfo;
          return (
            <div>
              <div data-tip={dataTip} data-for={dataFor} style={style || {}}>
                <StyledButton
                  primary
                  style={{ fontSize: "12px", margin: "0px" }}
                  label={label}
                  onClick={() => presenter.onRequestDocument()}
                  loading={loading}
                />
              </div>
              <ReactTooltip
                id={id}
                type={type}
                effect={effect}
                place={place || "top"}
              />
            </div>
          );
        } else {
          return (
            <StyledButton
              primary
              style={{ fontSize: "12px", margin: "0px" }}
              label={label}
              onClick={() => presenter.onRequestDocument()}
              loading={loading}
            />
          );
        }
      }
    };

    return (
      <div>
        {button(icon)}

        <DocumentViewer
          title={title}
          onHide={() => presenter.onHideDocument()}
          visible={document.visible}
          documentName={document.name}
          data={document.blob}
        />
      </div>
    );
  }
}

export default ViewDocumentButtonView;



// WEBPACK FOOTER //
// ./src/components/support/view-document-button/view.jsx